import { ConnectButton } from "@rainbow-me/rainbowkit"

import { useEffect } from "react"

import { useAnalytics } from "hooks/useAnalytics"
import { useAccount } from "wagmi"
import Button from "./Button"
import { useSelector } from "react-redux"
import { selectError, setError } from "features/errorSlice"
import Banner from "./Banner"
import { useAppDispatch } from "store"

export default function RainbowConnectWalletBtn({
  text,
  hide,
  showConnectedButton = false,
  hideError = false,
}: {
  text?: string
  hide?: boolean
  showConnectedButton?: boolean
  hideError?: boolean
}) {
  const { track } = useAnalytics()
  const accountData = useAccount()
  const errorMsg = useSelector(selectError)
  const dispatch = useAppDispatch()

  useEffect(() => {
    console.log("[useEffect in ConnectWalletBtn]", {
      hide,
      accountData,
    })
    if (hide || !accountData.isConnected) return

    track("wallet_connected", {
      address: accountData.address,
    })
  }, [accountData.isConnected])

  if (hide) return null

  if (errorMsg.msg && !hideError) {
    return (
      <div className="flex justify-center flex-col space-y-2">
        <Banner type="error" text={errorMsg.msg} />
        <Button
          className="text-sm text-gray-400"
          onClick={() => dispatch(setError({ msg: "" }))}
        >
          OK
        </Button>
      </div>
    )
  }

  return (
    <div
      className="rainbow-connect-wallet-btn"
      onClick={() => {
        track("wallet_connect_button_clicked")
      }}
    >
      {showConnectedButton ? (
        <Button>Your wallet is already connected</Button>
      ) : (
        <ConnectButton
          showBalance={{ smallScreen: false, largeScreen: false }}
          label={text}
        />
      )}
    </div>
  )
}
